import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const AlertInfo = ({ title, description, CTA, cacheKey }) => {
   useLayoutEffect(() => {
      let $closeBannerElement = document.getElementById('closeBannerAlerteInfo')
      if ($closeBannerElement !== null) {
         $closeBannerElement.addEventListener('click', () => {
            document.getElementById('zone_alerte-info').classList.add('isClosed')
            // Expire same day midnight
            var d = new Date()
            var expireDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59)
            document.cookie = 'alerteInfo=1;expires=' + expireDate.toUTCString() + ';'
         })
      }
   }, [])

   return (
      <div id="zone_alerte-info" data-testid="alertInfo" class="zone-alerte-info" data-cache-key={cacheKey}>
         <div class="site-width alert-container alert-info pt-2">
            <div class="container-fluid">
               <p class="alert">
                  <span class="alert-icon icon-info mr-1" aria-hidden="true"></span>
                  <span data-testid="alert-info-title">{title}</span>
               </p>
               <div class="alert-content">
                  <p class="alert-text mw-100">
                     <span data-testid="alert-info-desc">{description}</span>&nbsp;
                     {CTA.URL !== '' && CTA.label !== '' ? (
                        <a
                           class="o-link-arrow"
                           href={CTA.URL}
                           data-oevent-category={CTA.analytics.category}
                           data-oevent-action={CTA.analytics.action}
                           data-oevent-label={CTA.analytics.label}
                           data-oevent-other={CTA.analytics.other}
                        >
                           {CTA.label}
                        </a>
                     ) : null}
                  </p>
               </div>
               <button type="button" id="closeBannerAlerteInfo" title="Fermer l'alerte info" aria-label="Fermer l'alerte info" class="closeBannerAlerteInfo">
                  &times;
               </button>
            </div>
         </div>
      </div>
   )
}
